export default {"src":"/_next/static/media/404.08a0da02.svg","height":89,"width":228};